import { getEmployeeDataById } from "../../api/employee"
import { useEffect, useState } from "react"
import { EmployeeProps } from "../../interfaces/employee_type"
import { EmployeeForm } from "./Form/EmployeeForm"
import { useParams } from "react-router-dom"

/**
 *  ### [Route for ('/create_employee')]
 * 
 * Create an employee and sends a POST request to the backend
 */
export function CreateEmployee() {
    return (
        <>
            <EmployeeForm method="POST"/>
        </>
    )
}

export function UpdateEmployee() {
    const { id } = useParams()
    if (!id) {
        console.error("No employee selected")
        return <div>No employee selected</div>
    }
    const [employeeData, setEmployeeData] = useState<EmployeeProps>()

    useEffect(() => {
        const fetchEmployeeData = async () => {
            try {
                const response = await getEmployeeDataById(id)
                setEmployeeData({...response, id: id})
            } catch (error) {
                console.error("Error fetching employee data:", error)
            }
        }

        fetchEmployeeData()
    }, [id])

    return (
        <>
            {employeeData && <EmployeeForm method="PUT" employee={employeeData as EmployeeProps}/>}
        </>
    )
}

